// User type constants
export const USER_ROLES = [
	{ value: 'admin', name: 'Administrators' },
	{ value: 'employee', name: 'Darbinieks' },
	{ value: 'teacher', name: 'Pedagogs' },
	{ value: 'student', name: 'Students' },
	{ value: 'parent', name: 'Vecāks' }
];

// Exam status constants
export const USER_STATES = [
	{ value: 'active', name: 'Aktīvs', theme: 'success' },
	{ value: 'suspended', name: 'Ierobežots', theme: 'warning' },
	{ value: 'blocked', name: 'Bloķēts', theme: 'danger' }
];

// User status constants
export const USER_GENDERS = [
	{ value: 'male', name: 'Vīrietis' },
	{ value: 'female', name: 'Sieviete' },
	{ value: 'other', name: 'Cits' }
];

// Grade state constants
export const GRADE_STUDENT_STATES = [
	{ value: 'assigned', text: 'Pievienots', theme: '' },
	{ value: 'active', text: 'Aktīvs', theme: 'success' },
	{ value: 'finished', text: 'Pabeidzis', theme: 'indigo' },
	{ value: 'graduated', text: 'Absolvējis', theme: 'indigo' },
	{ value: 'rejected', text: 'Atskaitīts', theme: 'danger' }
];

// Exam type constants
export const EXAM_TYPES = [
	{
		value: 1,
		text: 'Ieskaite',
		icon: 'assignment',
		description: 'Vērtēta ar atzīmi skalā 1-10'
	},
	{
		value: 2,
		text: 'Pašpārbaudes darbs',
		icon: 'assignment_turned_in',
		description: 'Students pārbauda savas zināšas'
	}
];

// Exam status constants
export const EXAM_STATES = [
	{ value: 'visible', text: 'Redzams', theme: 'success' },
	{ value: 'hidden', text: 'Slēpts', theme: 'warning' },
	{ value: 'archived', text: 'Arhivēts', theme: 'danger' }
];

// Exam student's status constants
export const EXAM_STUDENT_STATES = [
	{ value: 'assigned', text: 'Pievienots', theme: '' },
	{ value: 'active', text: 'Tiek pildīts', theme: 'informative' },
	{ value: 'finished', text: 'Iesniegts', theme: 'warning' },
	{ value: 'reviewed', text: 'Novērtēts', theme: 'success' },
	{ value: 'rejected', text: 'Anulēts', theme: 'danger' }
];

// Task type constants
export const TASK_TYPES = [
	{
		value: 'quiz',
		text: 'Tests',
		icon: 'list',
		description: 'Jautājumi ar atbilžu izvēli'
	},
	{
		value: 'essay',
		text: 'Eseja',
		icon: 'article',
		description: 'Brīvās atbildes lauks'
	},
	{
		value: 'multiple',
		text: 'Vairākas atbildes',
		icon: 'dynamic_feed',
		description: 'Jautājumi ar brīvās atbildes lauku'
	},
	{
		value: 'spellcheck',
		text: 'Vārdu ievietošana',
		icon: 'spellcheck',
		description: 'Teksts ar izlaistiem vārdiem'
	},
	{
		value: 'connect',
		text: 'Terminu savienošana',
		icon: 'share',
		description: 'Savienot terminu ar paskaidrojumu'
	},
	{
		value: 'upload',
		text: 'Faila augšuplāde',
		icon: 'upload',
		description: 'Atbildes iesniegšana ar failu'
	}
];

// Material status constants
export const MATERIAL_STATES = [
	{ value: 'visible', text: 'Redzams', theme: 'success' },
	{ value: 'hidden', text: 'Slēpts', theme: 'warning' },
	{ value: 'archived', text: 'Arhivēts', theme: 'danger' }
];

// Material type constants
export const MATERIAL_TYPES = [
	{
		value: 'document',
		text: 'Dokuments',
		icon: 'article',
		description: 'Grāmata'
	},
	{
		value: 'file',
		text: 'Fails',
		icon: 'attach_file',
		description: 'Lejupielādējams palīgmateriāls'
	},
	{
		value: 'video',
		text: 'Video',
		icon: 'video_library',
		description: 'Ārējas saites video'
	}
];

// Webinar status constants
export const WEBINAR_STATES = [
	{ value: 'hidden', text: 'Slēpts', theme: 'warning' },
	{ value: 'visible', text: 'Redzams', theme: 'success' },
	{ value: 'archived', text: 'Arhivēts', theme: 'danger' },
];

// Webinar status constants
export const WEBINAR_TYPES = [
	{ value: 'online', text: 'Tiešsaiste', theme: 'informative' },
	{ value: 'record', text: 'Ieraksts', theme: '' }
];

// Browser sort constants
export const BROWSER_TYPES = [
	{
		name: 'all',
		text: 'Visi'
	},
	{
		name: 'image',
		text: 'Attēli'
	},
	{
		name: 'video',
		text: 'Video'
	},
	{
		name: 'audio',
		text: 'Audio'
	}
];

export const PAYMENT_TYPES = [
	{ value: 'scholarship', text: 'Mācību maksa', theme: 'success' },
	{ value: 'enrolment', text: 'Uzņemšanas maksa', theme: 'warning' },
	{ value: 'redo', text: 'Pārkārtošanas maksa', theme: 'informative' }
];

export const PAYMENT_STATES = [
	{ value: 'scheduled', text: 'Plānots', theme: '' },
	{ value: 'partial', text: 'Daļēji apmaksāts', theme: 'warning' },
	{ value: 'executed', text: 'Apmaksāts', theme: 'success' }
];

export const MARK_TYPES = [
	{ value: 'transferred', text: 'Pārnests vērtējums' },
	{ value: 'middle', text: 'Starpvērtējums' },
	{ value: 'final', text: 'Gala vērtējums' }
];

// Article status constants
export const ARTICLE_STATES = [
	{ value: 'visible', text: 'Redzams', theme: 'success' },
	{ value: 'hidden', text: 'Slēpts', theme: 'warning' }
];

// Article status constants
export const DOCUMENT_STATES = [
	{ value: 'visible', text: 'Redzams', theme: 'success' },
	{ value: 'hidden', text: 'Slēpts', theme: 'warning' }
];

// Article status constants
export const DOCUMENT_TYPES = [
	{ value: 'general', text: 'Vispārīgs' },
	{ value: 'exam', text: 'Eksāmens' }
];

// Subject category constants
export const SUBJECT_CATEGORIES = [
	{ value: 'basic', text: 'pamatkurss' },
	{ value: 'advanced', text: 'padziļinātais kurss' },
	{ value: 'specialized', text: 'specializētais kurss' }
];

// Subject level constants
export const SUBJECT_LEVELS = [
	{ value: 'optimal', text: 'optimālajā mācību satura apguves līmenī' },
	{ value: 'general', text: 'vispārīgajā mācību satura apguves līmenī' },
	{ value: 'high', text: 'augstākajā mācību satura apguves līmenī' }
];

// Grade direction constants
export const GRADE_STUDENT_DIRECTIONS = [
	{ value: 'general', text: 'vispārīgais' },
	{ value: 'humanitarian', text: 'humanitārais' },
	{ value: 'programming', text: 'programmēšanas' }
];


export const MARK_VALUES = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 'nv'];